import { ArrowDown } from "./icones";
import TextoSuporte from "./TextoSuporte";
import css from "./SuporteIA.module.css";

/** Passo a passo em cards: um por passo, título em negrito e explicação. O botão da tela (guia) fica na bolha. */
export default function CardsDePassos({ passos }) {
  return (
    <ol aria-label={passos.artigo.titulo} className={css.cards}>
      {passos.cards.map((c, i) => (
        <li key={i} className={css.cardItem}>
          <div className={css.cardPasso}>
            <span aria-hidden="true" className={css.cardNumero}>
              {i + 1}
            </span>
            <div className={css.cardTexto}>
              <p className={css.cardTitulo}>{c.titulo}</p>
              {c.sub && (
                <div className={css.cardSub}>
                  <TextoSuporte texto={c.sub} />
                </div>
              )}
            </div>
          </div>
          {i < passos.cards.length - 1 && <ArrowDown size={16} className={css.cardSeta} />}
        </li>
      ))}
    </ol>
  );
}

